import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT =
    process.env.REACT_APP_ENDPOINT + "/api/x-admin/api-providers";

const getAllProvidersProducts = id => {
    return axios.get(`${API_ENDPOINT}/${id}/list-products`, {
        withCredentials: true,

        headers: {
            ...authHeader(),
        },
    });
};
const getAllProviders = async () => {
    const response = await axios.get(API_ENDPOINT, {
        withCredentials: true,

        headers: {
            ...authHeader(),
        },
    });
    return response.data;
};

const providerServices = {
    getAllProviders,
    getAllProvidersProducts,
};

export default providerServices;
